module.exports = __webpack_public_path__ + "static/img/禁毒教育展厅.04a95584.png";